import React from "react"
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData, toggleHttps } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";

const ImageCoverPage = (props) => {
  const { name, title, type, reportData, reportItem, searchTags, summarizeGeographies, priorYearPeriodName, currentPeriodName, customDate, color , AiResponse, formValues, defaultLogo, user, dateDisplay, defaultImage } = props;
  if(!formValues) return null;
  if(formValues && formValues.cover && formValues.cover=='hide') return null;
  return (
	<div className="report-container page-section cover-page image-cover-page no-header">
	    <section className="report-section">
			
	
	          <h1 className="cover-title editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}<br/> {title || reportItem.name}</h1>
			  <hr/>
			  <div>
				{dateDisplay ? 
                <div className="cover-date editable">{dateDisplay}</div>
                :
                <div className="cover-date editable">{priorYearPeriodName} vs. {currentPeriodName}</div>
                }
			  </div>
              <div className="cover-image-container">
        
                <img src={ defaultImage ? defaultImage : "https://marketproof-hosting.s3.us-east-1.amazonaws.com/nyc-background.jpg"} data-compression-width="1000" data-compression-quality="100" className="full-cover-image" id="cover-image" />
        
                <div className="trigger-upload-image print-hide" data-image-key={"cover-image"}><span>Change Photo</span></div>
              </div>
			  <div className="image-cover-logo">
              <div>
              {user &&
              user.corpLogo ? (
              <img className="" src={user.corpLogo} />
              
              ):null}
              </div>
              <div>
              {formValues &&
              formValues.branding &&
              (formValues.branding === "mylogo" || (!user.corpLogo && formValues.branding === "marketproof")) &&
              user &&
              user.logo ? (
              <img className="" src={user.logo} />
              ) : null}
              </div>
            </div>
		</section>
	</div>
  );
};

export default ImageCoverPage;